module.exports = __webpack_public_path__ + "img/waternormals.4418dde3.jpg";